import styled from "styled-components";

const SideBarStyled = styled.div`
  background-image: url("../Img/blue-circuit-board-background.jpg");

  .logo {
    .small {
      width: 60px;
      height: 40px;
    }
    .large {
      width: 150px;
    }
    .left-arrow {
      left: 23.7vw;
      top: 1.3vw;
    }
    .right-arrow {
      left: 3.9vw;
      top: 1.3vw;
    }
  }

  .options {
    width: max-content;
    .category {
      width: 95%;
      cursor: pointer;
      .icon {
        height: 23px;
        width: 23px;
        color: #fff;
      }
      :hover {
        background-color: #686868;
        span {
          color: #fff !important;
        }
      }
    }
  }
`;

export default SideBarStyled;
